import { useSelector } from "react-redux";
import { FirebaseState } from "../../utilities/firebaseState";
import { LoginState } from "./slice";

export const useLoginState = () => {
    return useSelector(
        (state: { login: LoginState; firebase: FirebaseState }) => state
    );
};
